import { Button, colors } from '@spritz-finance/ui'
import React, { useState } from 'react'
import { DIRECT_PAY_OPENED_EVENT } from '../../../analytics/events'
import { useAnalytics } from '../../../context/useAnalytics'
import { AccountProvider, FullSpritzCardFragment } from '../../../graphql/generated/graphql'
import { useWalletDialog } from '../../../web3/connectDialog/WalletConnectDialogProvider'
import { useWeb3Connection } from '../../../web3/Web3Provider'
import { DirectPayDialog } from '../../bills/components/directPay/DirectPayDialog'
import { DirectPayType } from '../../bills/components/directPay/context/DirectPayContext'

type DirectPayButtonProps = {
    account: FullSpritzCardFragment
}

export const PaymentButton: React.VFC<DirectPayButtonProps> = ({ account }) => {
    const { connected } = useWeb3Connection()
    const { openWalletConnectDialog } = useWalletDialog()
    const { trackAnalyticsEvent } = useAnalytics()
    const [paymentDialog, setDirectPayDialogOpen] = useState(false)

    const handleOffRamp = () => {
        trackAnalyticsEvent(DIRECT_PAY_OPENED_EVENT, {
            type: DirectPayType.SpritzCard,
        })
        if (connected) {
            setDirectPayDialogOpen(true)
        } else {
            openWalletConnectDialog(() => setDirectPayDialogOpen(true))
        }
    }

    return (
        <>
            <Button.CTA variant="gradient" onClick={handleOffRamp} color={colors.brand}>
                Fund with Crypto
            </Button.CTA>

            <DirectPayDialog
                title="Fund your SpritzCard"
                type={DirectPayType.SpritzCard}
                open={paymentDialog}
                onClose={() => setDirectPayDialogOpen(false)}
                account={{
                    accountId: account.id,
                    provider: AccountProvider.Checkbook,
                    name: 'SpritzCard',
                    ownedByUser: true,
                }}
                fullAccount={account}
            />
        </>
    )
}
